export const LOAD_PAYMENT_OPTIONS_METADATA_SUCCESS = 'LOAD_PAYMENT_OPTIONS_METADATA_SUCCESS';

export default LOAD_PAYMENT_OPTIONS_METADATA_SUCCESS;
